import React, { useEffect, useState } from "react";
import axios from "axios";

const Profile = () => {
  const [user, setUser] = useState(null); // ইউজারের ডেটা
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("token"); // লগইন হলে সেভ করা token
        if (!token) return;

        const res = await axios.get("https://api.earnmoney0.top/api/user/me", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser({
  ...res.data,
  todayIncome: res.data.todayIncome || 0,
  totalIncome: res.data.totalIncome || 0,
});
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  return (
    <div className="profile-page">
      {/* HEADER */}
      <div className="profile-header">
        <button onClick={() => window.history.back()} className="back-btn">
          ←
        </button>
        <h3>Profile</h3>
      </div>

      {/* AVATAR */}
      <div className="avatar-box">
        <img
          src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
          alt="profile"
          className="profile-avatar"
        />
      </div>

      {/* INFO CARD */}
      <div className="profile-card">
        <ProfileItem
          icon="👤"
          label="Name"
          value={loading ? "Loading..." : user?.name || "-"}
        />
        <ProfileItem
          icon="📞"
          label="Mobile Number"
          value={loading ? "Loading..." : user?.phone || "-"}
        />
        <ProfileItem
  icon="💰"
  label="Main Balance"
  value={
    loading
      ? "Loading BDT"
      : `৳ ${ (user?.mainBalance || 0) }`
  }
/>
<ProfileItem
  icon="🏦"
  label="Deposit Balance"
  value={loading ? "Loading BDT" : `৳ ${user?.depositBalance || 0}`}
/>
        <ProfileItem
  icon="📦"
  label="Package"
  value={
    loading
      ? "Loading"
      : Array.isArray(user?.purchasedPackages)
        ? user.purchasedPackages.join("+")
        : (typeof user?.purchasedPackages === "string" ? user.purchasedPackages.split(" + ").join("+") : "-")
  }
/>
        <ProfileItem
          icon="🎁"
          label="Refer Code"
          value={loading ? "Loading" : user?.referCode || "-"}
        />
        <ProfileItem
          icon="📈"
          label="Today Income"
          value={loading ? "Loading BDT" : `৳ ${user?.todayIncome || 0}`}
        />
        <ProfileItem
          icon="💸"
          label="Total Income"
          value={loading ? "Loading BDT" : `৳ ${user?.totalIncome || 0}`}
        />
      </div>

      {/* --- CSS --- */}
      <style>{`
        .profile-page {
          min-height: 100vh;
          background: linear-gradient(135deg, #6a0dad, #f3f3f3);
        }
        .profile-header {
          background: #6a0dad;
          color: #fff;
          padding: 16px 20px;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .back-btn {
          background: transparent;
          border: none;
          color: #fff;
          font-size: 22px;
          cursor: pointer;
        }
        .avatar-box {
          display: flex;
          justify-content: center;
          margin-top: 30px;
        }
        .profile-avatar {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: #ffc107;
          padding: 10px;
        }
        .profile-card {
          background: #fff;
          margin: 16px;
          border-radius: 14px;
          padding: 12px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }
        .profile-row {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 14px 6px;
          border-bottom: 1px solid #eee;
          font-size: 14px;
        }
        .profile-row:last-child {
          border-bottom: none;
        }
        .row-icon {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background: #6a0dad;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          flex-shrink: 0;
        }
        .row-text {
          display: flex;
          gap: 6px;
        }
        .row-text strong {
  color: #4b0082;       /* গাঢ় ইন্ডিগো, লেবেল স্পষ্ট কিন্তু ভ্যালুর থেকে আলাদা */
  font-size: 16px;
  font-weight: 700;
}

.row-text span {
  color: #1e3a8a;       /* ডিপ ব্লু, চোখে পড়বে কিন্তু শক্ত নট কালো নয় */
  font-weight: 600;
  font-size: 16px;
}
        @media (min-width: 1024px) {
          .avatar-box {
            margin-top: 50px;
          }
          .profile-avatar {
            width: 140px;
            height: 140px;
          }
          .profile-card {
            max-width: 900px;
            margin: 40px auto;
            padding: 30px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            column-gap: 30px;
          }
          .profile-row {
            font-size: 15px;
            padding: 16px 10px;
          }
          .profile-header {
            padding: 20px 40px;
          }
        }
      `}</style>
    </div>
  );
};

const ProfileItem = ({ icon, label, value }) => (
  <div className="profile-row">
    <div className="row-icon">{icon}</div>
    <div className="row-text">
      <strong>{label} :</strong>
      <span>{value}</span>
    </div>
  </div>
);

export default Profile;